import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";



const AU_STATES = [
  "VIC",
  "NSW",
  "QLD",
  "WA",
  "SA",
  "TAS",
  "ACT",
  "NT",
];

const POOL_TYPES = ["Inground", "Above Ground"];

const POOL_SIZES = ["Small", "Medium", "Large"];

const POOL_SURFACES = ["Concrete", "Vinyl Liner", "Fiberglass"];

const SERVICE_FREQUENCIES = [
  "Weekly",
  "Fortnightly",
  "Every 3 Weeks",
  "Monthly",
];

const SERVICE_DAYS = [
  "Any Day",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const SERVICE_TIMES = [
  "Any Time",
  "Morning",
  "Afternoon",
];

const ACCESS_TYPES = [
  "Easy Access",
  "Side Gate",
  "Backyard Access",
  "Locked Gate",
  "Apartment / Unit",
  "Other",
];





/* =========================================================
   POST POOL CARE SWAP LISTING
========================================================= */

const SERVICE_TASKS = [
  { key: "waterTesting", label: "Water testing" },
  { key: "chemicalBalancing", label: "Chemical balancing" },
  { key: "skimming", label: "Skimming" },
  { key: "vacuuming", label: "Vacuuming" },
  { key: "brushing", label: "Brushing" },
  { key: "filterCleaning", label: "Filter cleaning" },
  { key: "saltCellCleaning", label: "Salt cell cleaning" },
  { key: "chemicalSupplyIncluded", label: "Chemicals included" },
];

function PostPoolCareSwapListings() {
  const navigate = useNavigate();

    
const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);

  const [form, setForm] = useState({
    swap_from_suburb: "",
    swap_from_postcode: "",
    swap_from_state: "VIC",

    swap_to_suburb: "",
    swap_to_postcode: "",
    swap_to_state: "VIC",

    poolType: "",
    poolSize: "",
    poolSurface: "",
    hasSpa: false,

    frequency: "",
    serviceDay: "",
    serviceTime: "",

    accessType: "",
    streetParking: false,
    petsAtHome: false,
    alarmCodeRequired: false,

    serviceFee: "",
    services: {},
  });

  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  /* ---------------- handlers ---------------- */

  const update = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const toggleService = (key) => {
    setForm((prev) => ({
      ...prev,
      services: {
        ...prev.services,
        [key]: !prev.services[key],
      },
    }));
  };

  /* ---------------- submit ---------------- */

  const submit = async (e) => {
    e.preventDefault();
    setError("");

    if (
  !form.poolType ||
  !form.poolSize ||
  !form.poolSurface ||
  !form.frequency ||
  !form.serviceDay ||
  !form.serviceTime ||
  !form.accessType
) {
  setError("Please complete all required fields.");
  return;
}


    try {
      setSubmitting(true);

      const token = localStorage.getItem("token");

      const res = await fetch(
        `${API_BASE_URL}/api/poolcare/swap-listings/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        body: JSON.stringify({
  ...form,
  disclaimerAccepted, // ✅ SEND IT
  serviceFee: form.serviceFee
    ? Number(form.serviceFee)
    : null,
}),

        }
      );

      const data = await res.json();

      if (!res.ok || data.success === false) {
        setError(data.error || "Failed to create swap listing");
        return;
      }

      navigate(`/poolcare/swap-listing-success/${data.listingId}`);

    } catch (err) {
      console.error(err);
      setError("Something went wrong creating the swap listing");
    } finally {
      setSubmitting(false);
    }
  };

  /* ---------------- render ---------------- */

  return (
    <div style={container}>
      <h2>🔁 Post Pool Care Swap</h2>

      {error && <p style={{ color: "red" }}>{error}</p>}

      <form onSubmit={submit}>
        {/* LOCATIONS */}
        <Section title="Swap Locations">
          <Input label="From Suburb" name="swap_from_suburb" onChange={update} />
          <Input label="From Postcode" name="swap_from_postcode" onChange={update} />
          <Select
  label="From State"
  name="swap_from_state"
  value={form.swap_from_state}
  onChange={update}
  options={AU_STATES}
/>

          <Input label="To Suburb" name="swap_to_suburb" onChange={update} />
          <Input label="To Postcode" name="swap_to_postcode" onChange={update} />
          <Select
  label="To State"
  name="swap_to_state"
  value={form.swap_to_state}
  onChange={update}
  options={AU_STATES}
/>
        </Section>

        {/* POOL */}
        <Section title="Pool Details">
  <Select
    label="Pool Type"
    name="poolType"
    value={form.poolType}
    onChange={update}
    options={POOL_TYPES}
  />

  <Select
    label="Pool Size"
    name="poolSize"
    value={form.poolSize}
    onChange={update}
    options={POOL_SIZES}
  />

  <Select
    label="Pool Surface"
    name="poolSurface"
    value={form.poolSurface}
    onChange={update}
    options={POOL_SURFACES}
  />

  <Checkbox
    label="Spa Included"
    name="hasSpa"
    checked={form.hasSpa}
    onChange={update}
  />
</Section>


       <Section title="Service Schedule">
  <Select
    label="Frequency"
    name="frequency"
    value={form.frequency}
    onChange={update}
    options={SERVICE_FREQUENCIES}
  />

  <Select
    label="Service Day"
    name="serviceDay"
    value={form.serviceDay}
    onChange={update}
    options={SERVICE_DAYS}
  />

  <Select
    label="Service Time"
    name="serviceTime"
    value={form.serviceTime}
    onChange={update}
    options={SERVICE_TIMES}
  />
</Section>


        {/* SERVICES */}
        <Section title="Included Services">
          <div style={grid}>
            {SERVICE_TASKS.map((s) => (
              <Checkbox
                key={s.key}
                label={s.label}
                checked={!!form.services[s.key]}
                onChange={() => toggleService(s.key)}
              />
            ))}
          </div>
        </Section>

        {/* ACCESS */}
       <Section title="Access">
  <Select
    label="Access Type"
    name="accessType"
    value={form.accessType}
    onChange={update}
    options={ACCESS_TYPES}
  />

  <Checkbox
    label="Street Parking"
    name="streetParking"
    checked={form.streetParking}
    onChange={update}
  />
  <Checkbox
    label="Pets At Home"
    name="petsAtHome"
    checked={form.petsAtHome}
    onChange={update}
  />
  <Checkbox
    label="Alarm Code Required"
    name="alarmCodeRequired"
    checked={form.alarmCodeRequired}
    onChange={update}
  />
</Section>


        {/* FINANCIAL */}
        <Section title="Swap Value">
          <Input
            label="What You Charge Per Visit ($)"
            name="serviceFee"
            type="number"
            onChange={update}
          />
        </Section>

{/* DISCLAIMER */}
<div style={{
  marginTop: "20px",
  padding: "15px",
  backgroundColor: "#f9f9f9",
  borderRadius: "8px",
  border: "1px solid #ddd"
}}>
  <label style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
    <input
      type="checkbox"
      checked={disclaimerAccepted}
      onChange={(e) => setDisclaimerAccepted(e.target.checked)}
      required
      style={{ marginTop: "5px" }}
    />
    <span style={{ fontWeight: "bold" }}>I confirm that:</span>
  </label>

  <ul style={{
    fontSize: "0.9rem",
    color: "#333",
    marginTop: "10px",
    marginLeft: "30px",
    lineHeight: "1.6"
  }}>
    <li>All information provided is accurate and not misleading</li>
    <li>I am solely responsible for this listing</li>
    <li>Client Exchange™ does not verify or guarantee any listing information</li>
    <li>I have authority to transfer this client</li>
    <li>This does not breach any agreement (including franchise or contractual obligations)</li>
    <li>
  I agree to be bound by the Client Exchange™ terms,
  conditions, and policies listed on the website from time to time
</li>
  </ul>

  <p style={{
    fontSize: "0.8rem",
    color: "#666",
    marginTop: "10px"
  }}>
    Listings must comply with any applicable agreements or obligations held by the seller.
  </p>
</div>

        <button
  type="submit"
  disabled={submitting || !disclaimerAccepted}
  style={{
    ...submitBtn,
    backgroundColor:
      submitting || !disclaimerAccepted ? "#9e9e9e" : "#2e7d32",
    cursor:
      submitting || !disclaimerAccepted ? "not-allowed" : "pointer",
  }}
>
  {submitting ? "Posting…" : "Post Pool Care Swap"}
</button>

      </form>
    </div>
  );
}

/* ---------------- helpers ---------------- */

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 25 }}>
    <h3>{title}</h3>
    {children}
  </div>
);

const Input = ({ label, ...props }) => (
  <div style={{ marginBottom: 10 }}>
    <label>
      {label}
      <input {...props} style={input} />
    </label>
  </div>
);

const Checkbox = ({ label, ...props }) => (
  <label style={checkbox}>
    <input type="checkbox" {...props} />
    {label}
  </label>
);

const Select = ({ label, name, value, onChange, options }) => (
  <div style={{ marginBottom: 10 }}>
    <label>
      {label}
      <select
        name={name}
        value={value}
        onChange={onChange}
        style={input}
        required
      >
        <option value="">Select {label}</option>
        {options.map((opt) => (
          <option key={opt} value={opt}>
            {opt}
          </option>
        ))}
      </select>
    </label>
  </div>
);


/* ---------------- styles ---------------- */

const container = {
  maxWidth: 700,
  margin: "40px auto",
  background: "#fff",
  padding: 30,
  borderRadius: 12,
  boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
};

const input = {
  width: "100%",
  padding: 8,
  marginTop: 4,
};

const checkbox = {
  display: "block",
  marginBottom: 6,
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 8,
};

const submitBtn = {
  width: "100%",
  padding: 14,
  background: "#2e7d32",
  color: "#fff",
  fontSize: "1rem",
  fontWeight: "bold",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
};

export default PostPoolCareSwapListings;

